import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

import { HttpService } from '../../../tms-shared';
import { TmsWebBaseChartService } from '../base';
import { ChartWeeksSalesOrders } from '../../models';

@Injectable({
  providedIn: 'root',
})
export class ChartWeeksSalesOrdersService extends TmsWebBaseChartService<ChartWeeksSalesOrders> {
  public refreshDetails = new Subject<void>();

  constructor(protected httpService: HttpService) {
    super('ChartWeeksSalesOrders', httpService);
  }
}
